/* eslint-disable no-shadow */
export enum localStorageValueEnum {
  theme = 'theme',
}

// When you change that value, change also width in GlobalScssVariables.scss
export enum MobileWidthsEnum {
  mobilePhoneWidth = 600,
}
